import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Building2, UserCheck, Store } from "lucide-react";
import { authLabels } from "@/i18n";

interface AccountTypeSelectorProps {
  onSelectType: (type: 'dealer' | 'consumer' | 'business') => void;
}

const AccountTypeSelector = ({ onSelectType }: AccountTypeSelectorProps) => {
  const authLabels_i18n = authLabels();

  return (
    <div className="space-y-4">
      <div className="grid gap-3">
        <Card className="cursor-pointer hover:bg-accent/50 transition-colors" onClick={() => onSelectType('dealer')}>
          <CardContent className="p-4">
            <Button variant="ghostNoHover" className="w-full justify-start gap-3 h-auto p-0">
              <Store className="h-5 w-5 text-blue-500" />
              <div className="text-left">
                <div className="font-medium">{authLabels_i18n.accountTypes.dealer.title}</div>
                <div className="text-sm text-muted-foreground">{authLabels_i18n.accountTypes.dealer.description}</div>
              </div>
            </Button>
          </CardContent>
        </Card>

        <Card className="cursor-pointer hover:bg-accent/50 transition-colors" onClick={() => onSelectType('consumer')}>
          <CardContent className="p-4">
            <Button variant="ghostNoHover" className="w-full justify-start gap-3 h-auto p-0">
              <UserCheck className="h-5 w-5 text-green-500" />
              <div className="text-left">
                <div className="font-medium">{authLabels_i18n.accountTypes.consumer.title}</div>
                <div className="text-sm text-muted-foreground">{authLabels_i18n.accountTypes.consumer.description}</div>
              </div>
            </Button>
          </CardContent>
        </Card>

        <Card className="cursor-pointer hover:bg-accent/50 transition-colors" onClick={() => onSelectType('business')}>
          <CardContent className="p-4">
            <Button variant="ghostNoHover" className="w-full justify-start gap-3 h-auto p-0">
              <Building2 className="h-5 w-5 text-purple-500" />
              <div className="text-left">
                <div className="font-medium">{authLabels_i18n.accountTypes.business.title}</div>
                <div className="text-sm text-muted-foreground">{authLabels_i18n.accountTypes.business.description}</div>
              </div>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AccountTypeSelector;
